import paramsFactory from "../../utils/paramsFactory";
import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/admin/notifications?${p}`);
  },
  create(data, group) {
    return api.post(`/api/admin/notifications/${group}`, data);
  },
  delete(id) {
    return api.delete(`/api/admin/notifications/${id}`);
  },
};
